import React from "react";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { useNavigate } from "react-router-dom";

interface OwnProps {
	items: { id: string; internalTitle: string }[];
	deleteMessageDefinition: (internalTitle: string, id: string) => void;
}

export const MessageDefinitionTable = ({ items, deleteMessageDefinition }: OwnProps) => {
	const navigate = useNavigate();

	return (
		<DataTable
			className="p-mb-2"
			value={items}
			emptyMessage={"Keine Nachrichten-Vorlagen"}
			dataKey="id"
		>
			<Column header={"Interner Titel"} field="internalTitle" />
			<Column
				header={"Aktionen"}
				body={(item) => (
					<>
						<Button
							icon={"pi pi-pencil"}
							onClick={() => navigate(`/messaging/${item.id}/edit`)}
						/>
						<Button
							icon={"pi pi-send"}
							onClick={() => navigate(`/messaging/${item.id}/send`)}
							className={"ml-2"}
						/>
						<Button
							onClick={() => deleteMessageDefinition(item.internalTitle, item.id)}
							icon={"pi pi-trash"}
							className={"ml-2"}
						/>
					</>
				)}
			/>
		</DataTable>
	);
};
